import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import React from "react";

const outputSections = [
  [
    "top_oligos_new_ml_model",
    `Contains the top 50 siRNA predictions per the new ML model.
- Excludes sequences with GC > 56%, AAAA/GGGG/CCCC/UUUU stretches, cross-reactivity, or microRNA hits.`,
  ],
  [
    "top_oligos_old_model",
    "Contains the top ~50 siRNA predictions from the old linear model.",
  ],
  [
    "hits_to_mouse_and_nhp",
    "Contains sequences cross-reactive to mouse and human.",
  ],
  [
    "all_oligos",
    "Contains all predicted sequences (20nt sliding window).",
  ],
  ["run_info_old_model", "Info about the old linear model scoring."],
  ["run_info_new_ml_model", "Info about the new ML model scoring."],
];

export function OutputSectionsTable() {
  return (
    <>
      <Typography variant="h5" fontWeight={700} textAlign={"center"}>
        Output File Sections
      </Typography>
      
      <TableContainer component={Paper} elevation={1}>
        <Table size="small" sx={{ tableLayout: "fixed", borderCollapse: "collapse" }}>
          {/* Header Row */}
          <TableHead>
            <TableRow sx={{ backgroundColor: "action.selected" }}>
              <TableCell
                sx={{
                  fontWeight: 700,
                  borderRight: "1px solid",
                  borderColor: "divider",
                  textAlign: "center",
                  width: "30%",
                }}
              >
                Section Name
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 700,
                  textAlign: "center",
                }}
              >
                Description
              </TableCell>
            </TableRow>
          </TableHead>

          {/* Body Rows */}
          <TableBody>
            {outputSections.map(([section, desc], i) => (
              <TableRow key={i} sx={{ borderBottom: "1px solid", borderColor: "divider" }}>
                <TableCell
                  sx={{
                    fontWeight: 600,
                    borderRight: "1px solid",
                    borderColor: "divider",
                    width: "30%",
                    textAlign: "center",
                    verticalAlign: "middle",
                    backgroundColor: i % 2 === 0 ? "background.paper" : "action.hover",
                  }}
                >
                  {section}
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "pre-line",
                    textAlign: "left",
                    verticalAlign: "middle",
                    backgroundColor: i % 2 === 0 ? "background.paper" : "action.hover",
                  }}
                >
                  {desc}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}